import { compose } from 'recompose';

import SelectDropDownItemView from './SelectDropDownItemView';

export default compose()(SelectDropDownItemView);
